import { forwardRef, type Ref, type SVGProps } from "react";
const IconCheckmarkFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M29.41 6.57a2 2 0 0 0-2.83 0L11.36 21.32l-5.95-5.77a2 2 0 0 0-2.83 0 1.9 1.9 0 0 0 0 2.74L10 25.43a2 2 0 0 0 2.83 0L29.41 9.31a1.9 1.9 0 0 0 0-2.74" /></svg>;
const ForwardRef = forwardRef(IconCheckmarkFilledSVG);
ForwardRef.displayName = "IconCheckmarkFilled";
export { ForwardRef as IconCheckmarkFilled };